import { BehaviorSubject } from '../BehaviorSubject';
import { ConnectableObservable } from '../observable/ConnectableObservable';
export function publishBehavior(initialValue) {
    var subject = new BehaviorSubject(initialValue);
    return function (source) { return new ConnectableObservable(source, function () { return subject; }); };
}
//# sourceMappingURL=publishBehavior.js.map